class CredentialsLogin {
    constructor(documentId, password) {
        this.documentId = documentId;
        this.password = password;
    }
}

export default CredentialsLogin;